(function () {
  function ready() {
    var root = document.getElementById('lakoh-search');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    document.body.appendChild(root);
    var input = root.querySelector('input[name="q"]');
    var close = root.querySelector('.lakoh-search__close');
    var clear = root.querySelector('.lakoh-search__clear');
    var recent = root.querySelector('.lakoh-search__recent');
    var chips = root.querySelector('.lakoh-search__chips');
    var status = root.querySelector('.lakoh-search__status');
    var trend = root.querySelector('.lakoh-search__trend');
    var matches = root.querySelector('.lakoh-search__matches');
    var lastFocus, timer, sequence = 0;
    var storageKey = 'lakoh-recent-searches';
    function saved() { try { return JSON.parse(localStorage.getItem(storageKey) || '[]'); } catch (_) { return []; } }
    function save(term) { try { localStorage.setItem(storageKey, JSON.stringify([term].concat(saved().filter(function (item) { return item.toLowerCase() !== term.toLowerCase(); })).slice(0, 5))); } catch (_) {} renderRecent(); }
    function renderRecent() {
      var terms = saved();
      recent.hidden = !terms.length;
      chips.replaceChildren();
      terms.forEach(function (term) {
        var button = document.createElement('button');
        button.type = 'button'; button.textContent = term;
        button.addEventListener('click', function () { input.value = term; update(true); input.focus(); });
        chips.appendChild(button);
      });
    }
    var positionFrame;
    function positionPanel() {
      var header = document.getElementById('pageheader');
      if (header) root.style.setProperty('--search-hover-top', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
    }
    function queuePosition() {
      if (root.hidden || innerWidth < 768 || positionFrame) return;
      positionFrame = requestAnimationFrame(function () { positionFrame = null; positionPanel(); });
    }
    window.addEventListener('scroll', queuePosition, { passive: true });
    window.addEventListener('resize', queuePosition);
    function open(event) {
      event.preventDefault(); event.stopImmediatePropagation();
      root.classList.remove('is-hover-preview');
      input.placeholder = 'I’m looking for...';
      positionPanel();
      lastFocus = event.currentTarget;
      document.getElementById('main-search')?.classList.remove('main-search--open');
      root.hidden = false; root.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = innerWidth < 768 ? 'hidden' : '';
      input.value = ''; update(false); renderRecent(); input.focus({ preventScroll: true });
    }
    function dismiss() {
      root.hidden = true; root.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      clearTimeout(timer); sequence++;
      if (lastFocus && lastFocus.matches('.show-search-link')) lastFocus.focus();
    }
    document.querySelectorAll('#pageheader .show-search-link, #pageheader .test-search').forEach(function (button) { button.addEventListener('click', open, true); });
    document.querySelectorAll('#pageheader .lakoh-desktop-actions .show-search-link').forEach(function (button) {
      button.addEventListener('mouseenter', function (event) {
        if (!root.hidden || !matchMedia('(hover:hover) and (pointer:fine)').matches) return;
        open(event);
        root.classList.add('is-hover-preview');
        positionPanel();
        document.documentElement.style.overflow = '';
        input.placeholder = "I’m looking for...";
      });
    });
    root.addEventListener('mouseleave', function () { if (root.classList.contains('is-hover-preview') && !input.value.trim()) dismiss(); });
    input.addEventListener('input', function () { if (input.value.trim()) { root.classList.remove('is-hover-preview'); document.documentElement.style.overflow = innerWidth < 768 ? 'hidden' : ''; } });
    document.querySelectorAll('#pageheader .test-search input').forEach(function (field) {
      field.addEventListener('focus', function (event) { if (root.hidden) open(event); });
    });
    document.querySelectorAll('#pageheader .test-search form').forEach(function (form) {
      form.addEventListener('submit', open, true);
    });
    close.addEventListener('click', dismiss);
    document.addEventListener('keydown', function (event) { if (!root.hidden && event.key === 'Escape') dismiss(); });
    root.querySelector('.lakoh-search__recent-head button').addEventListener('click', function () { try { localStorage.removeItem(storageKey); } catch (_) {} renderRecent(); });
    clear.addEventListener('click', function () { input.value = ''; update(false); input.focus(); });
    function card(product) {
        var link = document.createElement('a'); link.className = 'lakoh-search__card'; link.href = product.url;
        var photo = document.createElement('img'); photo.src = product.featured_image?.url || product.featured_image || ''; photo.alt = product.title; photo.loading = 'lazy';
        var title = document.createElement('span'); title.textContent = product.title;
        var amount = document.createElement('small'); amount.textContent = new Intl.NumberFormat('en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(Number(product.price_min || product.price || 0));
        link.append(photo, title, amount);
        return link;
    }
    function update(immediate) {
      var term = input.value.trim();
      var normalizedTerm = term.toLowerCase().replace(/\s+/g, ' ');
      root.querySelectorAll('.lakoh-search__hot a').forEach(function (tag) {
        tag.classList.toggle('is-matched', !!normalizedTerm && tag.textContent.toLowerCase().replace(/\s+/g, ' ').includes(normalizedTerm));
      });
      clear.hidden = !term;
      clearTimeout(timer); var current = ++sequence;
      if (!term) { status.textContent = ''; matches.hidden = true; trend.hidden = false; matches.replaceChildren(); return; }
      timer = setTimeout(function () {
        var url = '/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
        fetch(url).then(function (response) { if (!response.ok) throw new Error('Search failed'); return response.json(); }).then(function (data) {
          if (current !== sequence || root.hidden) return;
          var products = data.resources?.results?.products || [];
          save(term);
          matches.replaceChildren();
          if (products.length) { products.forEach(function (product) { matches.appendChild(card(product, true)); }); status.textContent = products.length + ' Search Results'; matches.hidden = false; trend.hidden = true; }
          else { status.textContent = 'No results for your search'; matches.hidden = true; trend.hidden = false; }
        }).catch(function () { if (current === sequence) { status.textContent = 'Search is temporarily unavailable'; matches.hidden = true; trend.hidden = false; } });
      }, immediate ? 0 : 250);
    }
    input.addEventListener('input', function () { update(false); });
    root.querySelector('form').addEventListener('submit', function (event) { event.preventDefault(); if (input.value.trim()) { save(input.value.trim()); update(true); } });
    trend.querySelectorAll('.lakoh-search__card').forEach(function (existing) {
      var product = { url:existing.href, title:existing.querySelector('span').textContent, featured_image:existing.querySelector('img')?.src, price:0 };
      var replacement = card(product, false);
      replacement.querySelector('small').textContent = existing.querySelector('small').textContent;
      existing.replaceWith(replacement);
    });
    renderRecent();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
  document.addEventListener('shopify:section:load', ready);
})();

